/**
 * number of bins before switching to dense mode
 * @internal
 */
export var DENSE_HISTOGRAM = 19;
/**
 * minimal width of a column to show the label in the header
 * @internal
 */
export var MIN_LABEL_WIDTH = 30;
/**
 * number of milliseconds to wait before a hovered canvas row will be replaced with a DOM one
 * @type {number}
 * @internal
 */
export var HOVER_DELAY_SHOW_DETAIL = 500;
export var GUESSED_ROW_HEIGHT = 18;
export var GUESSES_GROUP_HEIGHT = 40;
//# sourceMappingURL=constants.js.map